import React from 'react';

export const UpdatePermitDetailsActivityFeedItemDescription = props => {
    const {CustomEventData, Event} = props;

    return <p>
        {Event?.Activity?.User?.name} updated a {CustomEventData?.permitType} from {CustomEventData?.permitOrg} permit
        on {CustomEventData?.title}.
    </p>;
};


